// src/api/integrations.ts

import api from '@/lib/axios';
import type { AppInstance } from '@/types/app';
import type { Product } from '@/types/product';

/**
 * 集成产品到 App（创建关联）
 * POST /v1/developer/apps/{app_id}/products/{product_id}
 * @param appId - App ID
 * @param productId - 产品 ID
 */
export const integrateProductToApp = (
  appId: string,
  productId: string
): Promise<void> => {
  return api.post(`/developer/apps/${appId}/products/${productId}`);
};

/**
 * 取消产品集成（删除关联）
 * DELETE /v1/developer/apps/{app_id}/products/{product_id}
 * @param appId - App ID
 * @param productId - 产品 ID
 */
export const removeProductIntegration = (
  appId: string,
  productId: string
): Promise<void> => {
  return api.delete(`/developer/apps/${appId}/products/${productId}`);
};

/**
 * 获取产品关联的 App 列表
 * GET /v1/developer/products/{product_id}/apps
 * @param productId - 产品 ID
 */
export const getAppsByProduct = (productId: string): Promise<AppInstance[]> => {
  return api.get(`/developer/products/${productId}/apps`);
};

/**
 * 获取所有产品（用于绑定选择）
 * GET /v1/developer/products?page=1&size=1000
 */
export const getAllProductsForBinding = async (): Promise<Product[]> => {
  console.log('开始获取产品列表');
  
  try {
    // ✅ 根据你的 Axios 拦截器，api.get() 直接返回处理后的数据
    const response = await api.get('/developer/products?page=1&size=1000');
    
    console.log('产品列表响应:', response);
    console.log('响应类型:', typeof response);
    console.log('响应是否为数组:', Array.isArray(response));
    
    // 类型守卫函数
    const isArray = (data: unknown): data is unknown[] => {
      return Array.isArray(data);
    };
    
    const hasItemsArray = (data: unknown): data is { items: Product[] } => {
      return typeof data === 'object' && 
             data !== null && 
             'items' in data && 
             Array.isArray((data as { items: unknown }).items);
    };
    
    const hasDataArray = (data: unknown): data is { data: Product[] } => {
      return typeof data === 'object' && 
             data !== null && 
             'data' in data && 
             Array.isArray((data as { data: unknown }).data);
    };
    
    // 检查数据结构
    if (isArray(response)) {
      console.log('直接返回数组:', response);
      return response as Product[];
    }
    
    // 检查是否有 items 属性
    if (hasItemsArray(response)) {
      console.log('返回 items 数组:', response.items);
      return response.items;
    }
    
    // 检查是否有 data 属性
    if (hasDataArray(response)) {
      console.log('返回 data 数组:', response.data);
      return response.data;
    }
    
    console.log('未找到有效数据，返回空数组。');
    return [];
    
  } catch (error) {
    console.error('获取产品列表失败:', error);
    return [];
  }
};